import { createBrowserRouter, createRoutesFromElements, Route } from 'react-router-dom';
import App from './App';
import NewMainLayout from '@/components/layouts/NewMainLayout';
import DashboardLayout from '@/components/layouts/DashboardLayout';
import ProtectedRoute from '@/components/auth/ProtectedRoute';
import AdminRoute from '@/components/auth/AdminRoute';

// Public pages
import NewHomePage from '@/pages/NewHomePage';
import ExplorePage from '@/pages/ExplorePage';
import DropDetailsPage from '@/pages/DropDetailsPage';
import StreamPage from '@/pages/StreamPage';
import LiveStreams from '@/pages/LiveStreams';
import MarketplacePage from '@/pages/MarketplacePage';
import NFTDetailsPage from '@/pages/NFTDetailsPage';
import AboutPage from '@/pages/AboutPage';
import Governance from '@/pages/GovernanceNew';
import Academy from '@/pages/Academy';
import Faucet from '@/pages/Faucet';
import AdminAccess from '@/pages/AdminAccess';
import NotFound from '@/pages/NotFound';

// Protected pages
import DashboardPage from '@/pages/dashboard/DashboardPage';
import MyDropsPage from '@/pages/dashboard/MyDropsPage';
import CreateDropPage from '@/pages/dashboard/CreateDropPage';
import MyStreamsPage from '@/pages/dashboard/MyStreamsPage';
import CreateStreamPage from '@/pages/dashboard/CreateStreamPage';
import MyNFTsPage from '@/pages/dashboard/MyNFTsPage';
import MintNFTPage from '@/pages/dashboard/MintNFTPage';
import MyWalletPage from '@/pages/dashboard/MyWalletPage';
import SettingsPage from '@/pages/dashboard/SettingsPage';

// Admin pages
import AdminDashboardPage from '@/pages/admin/AdminDashboardPage';
import ManageUsersPage from '@/pages/admin/ManageUsersPage';
import ManageDropsPage from '@/pages/admin/ManageDropsPage';
import ManageStreamsPage from '@/pages/admin/ManageStreamsPage';
import PlatformSettingsPage from '@/pages/admin/PlatformSettingsPage';

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<App />} errorElement={<NotFound />}>
      <Route element={<NewMainLayout />}>
        <Route index element={<NewHomePage />} />
        <Route path="explore" element={<ExplorePage />} />
        <Route path="drops/:id" element={<DropDetailsPage />} />
        <Route path="streams" element={<LiveStreams />} />
        <Route path="stream/:id" element={<StreamPage />} />
        <Route path="marketplace" element={<MarketplacePage />} />
        <Route path="nft/:id" element={<NFTDetailsPage />} />
        <Route path="about" element={<AboutPage />} />
        <Route path="governance" element={<Governance />} />
        <Route path="academy" element={<Academy />} />
        <Route path="faucet" element={<Faucet />} />
        <Route path="admin-access" element={<AdminAccess />} />
      </Route>
      
      <Route path="dashboard" element={
        <ProtectedRoute>
          <DashboardLayout />
        </ProtectedRoute>
      }>
        <Route index element={<DashboardPage />} />
        <Route path="drops" element={<MyDropsPage />} />
        <Route path="drops/create" element={<CreateDropPage />} />
        <Route path="streams" element={<MyStreamsPage />} />
        <Route path="streams/create" element={<CreateStreamPage />} />
        <Route path="nfts" element={<MyNFTsPage />} />
        <Route path="nfts/mint" element={<MintNFTPage />} />
        <Route path="wallet" element={<MyWalletPage />} />
        <Route path="settings" element={<SettingsPage />} />
      </Route>
      
      <Route path="admin" element={
        <AdminRoute>
          <DashboardLayout isAdmin />
        </AdminRoute>
      }>
        <Route index element={<AdminDashboardPage />} />
        <Route path="users" element={<ManageUsersPage />} />
        <Route path="drops" element={<ManageDropsPage />} />
        <Route path="streams" element={<ManageStreamsPage />} />
        <Route path="settings" element={<PlatformSettingsPage />} />
      </Route>
    </Route>
  ),
  {
    future: {
      v7_startTransition: true,
      v7_relativeSplatPath: true
    }
  }
);

export default router;